import { memo, ReactElement, ReactNode, useCallback, useContext } from "react";
import classNames from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { NavbarContext } from "../../Navbar/NavbarContext/NavbarContext";
import { MenuItemType } from "../../NavbarMenu/types";
import { MenuItemExotic } from "./MenuItemExoticElement";

import styles from "../style.module.scss";

type MenuItemProps = {
  item?: MenuItemType,
  activeSubItem?: boolean,
  activeMenuItem?: boolean,
  children?: ReactElement,
  component?: ReactNode,
  className?: string,
  isMenu?: boolean,
  trigger?: "click" | "hover",
}

export const MenuItem = memo<MenuItemProps>((
  {
    item,
    activeSubItem,
    className,
    trigger = "hover",
    component,
    children,
    isMenu = false,
    activeMenuItem,
  }) => {

  const { pathname } = useLocation();
  const { setIsFade, setOpen } = useContext(NavbarContext);

  const onMouseEnter = useCallback(() => {
    if (isMenu && children?.props?.children?.length) {
      setIsFade(true);
      setOpen(undefined);
    }
  }, [ setOpen, setIsFade, isMenu, children ]);

  //dropdown for another element inside navbar with dropdown
  if (trigger === "click") {
    return (
      <MenuItemExotic setIsFade={setIsFade} setOpen={setOpen} component={component} children={children} />
    );
  }

  const itemBody = <>
    {!isMenu && item?.icon}
    <h2 className={classNames(styles.itemLabel, {
      [styles.menuLabel]: isMenu,
    })}>
      {item?.label}
    </h2>
  </>;

  return (
    <li
      id={item?.id}
      className={classNames(styles.itemWrap, className, styles.arrow, {
        [styles.item]: !isMenu,
        [styles.menuItem]: isMenu,

        [styles.activeItem]: !isMenu && (pathname === item?.path || (item?.path && pathname.includes(item.path))),
        [styles.activeSubItem]: activeSubItem,
        [styles.activeMenuItem]: activeMenuItem,

        [styles.itemArrow]: children?.props?.children?.length,
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={() => isMenu && setIsFade(false)}
      onMouseDown={(e) => e.preventDefault()}
      onClick={item?.onClick || undefined}
    >
      {
        item?.externalPath ?
          <a
            target="_blank"
            rel="noreferrer"
            href={item.externalPath}
            {...item.externalLinkProps}
            className={classNames(styles.itemBody, item.externalLinkProps?.className, {
              [styles.menuItemBody]: isMenu,
            })}
          >
            {itemBody}
          </a>
          : item?.path

            ? <NavLink
              end to={item.path}
              {...item.linkProps}
              className={classNames(styles.itemBody, item.linkProps?.className as string, {
                [styles.menuItemBody]: isMenu,
              })}
            >
              {itemBody}
            </NavLink>

            : <div className={classNames(styles.itemBody, {
              [styles.menuItemBody]: isMenu,
            })}>
              {itemBody}
            </div>
      }
      {/* Drop container body  */}
      {children}
    </li>
  );
});
